module.exports = __webpack_public_path__ + "static/media/Kasey M.9a6528f9.jpeg";